import React, { useEffect, useRef, useState } from 'react';
import { BarChart2, ShieldCheck, Martini, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';


const InvestmentApproach = () => {
  const Alternatives="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/home/Alternatives.svg";
  const DynamicSaftey="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/home/Dynamic+Saftey.svg";
  const FocusedEquity="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/home/Focused+equity.svg";
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.1 });

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  return (
      <div ref={componentRef} id="investmentApproach" className="font-sans max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <h2 className={`text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] text-center mb-16 transition-opacity duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          Gain Peace of Mind With Our Proven Strategies
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* FOCUSED EQUITY */}
          <div className={`flex flex-col items-center transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="flex justify-center items-center mb-6">
              <img src={FocusedEquity} alt="Focused Equity" className="w-24 h-24" />
            </div>
            <h3 className="text-2xl font-bold mb-6 text-center tracking-wide">FOCUSED EQUITY</h3>
            <div className="bg-white w-full h-52 shadow-md rounded-xl overflow-hidden">
              <div className="p-5">
                <h4 className="text-xl font-semibold mb-4">Better alpha with quality</h4>
                <div className="space-y-4">
                  <div className={`group flex items-center justify-between transition-all duration-500 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
                    <p className="text-gray-800 group-hover:text-blue-600 transition-colors">Roots & Wings Investment Philosophy</p>
                    <ArrowRight size={18} className="text-blue-1000 opacity-70 transform group-hover:translate-x-1 transition-transform duration-200 cursor-pointer transition-all" 
                    onClick={() => navigate('/roots-wings', { state: { fromHome: true } })}/>
                  </div>

                  <div className={`group flex items-center justify-between transition-all duration-500 delay-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
                    <p className="text-gray-800 group-hover:text-blue-600 transition-colors">Three Lens Framework</p>
                    <ArrowRight size={18} className="text-blue-1000 opacity-70 transform group-hover:translate-x-1 transition-transform duration-200 cursor-pointer transition-all"
                    onClick={() => navigate('/three-lens', { state: { fromHome: true } })} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* DYNAMIC SAFETY */}
          <div className={`flex flex-col items-center transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="flex justify-center items-center mb-6">
              <img src={DynamicSaftey} alt="Dynamic Safety" className="w-24 h-24" />
            </div>
            <h3 className="text-2xl font-bold mb-6 text-center tracking-wide">DYNAMIC SAFETY</h3>
            <div className="bg-white w-full h-52 shadow-md rounded-xl overflow-hidden">
              <div className="p-5">
                <h4 className="text-xl font-semibold mb-4">Harvest gains for cashflows</h4>
                <div className="space-y-4">
                  <div className={`group flex items-center justify-between transition-all duration-500 delay-400 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
                    <p className="text-gray-800 group-hover:text-amber-600 transition-colors">LSG framework for asset allocation</p>
                    <ArrowRight size={18} className="text-amber-1000 opacity-70 transform group-hover:translate-x-1 transition-transform duration-200 cursor-pointer transition-all"
                    onClick={() => navigate('/lsg', { state: { fromHome: true } })} />
                  </div>

                  <div className={`group flex items-center justify-between transition-all duration-500 delay-600 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
                    <p className="text-gray-800 group-hover:text-amber-600 transition-colors">Rebalancing periodically for safety</p>
                    {/* <Info size={18} className="text-amber-600 opacity-70 group-hover:opacity-100 cursor-pointer transition-all" /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ALTERNATES */}
          <div className={`flex flex-col items-center transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="flex justify-center items-center mb-6">
              <img src={Alternatives} alt="Alternatives" className="w-24 h-24" />
            </div>
            <h3 className="text-2xl font-bold mb-6 text-center tracking-wide">ALTERNATES</h3>
            <div className="bg-white w-full h-52 shadow-md rounded-xl overflow-hidden">
              <div className="p-5">
                <h4 className="text-xl font-semibold mb-4">Boost risk adjusted return</h4>
                <div className="space-y-4">
                  <div className={`group flex items-center justify-between transition-all duration-500 delay-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
                    <p className="text-gray-800 group-hover:text-blue-600 transition-colors">Active Momentum</p>
                    {/* <Info size={18} className="text-blue-500 opacity-70 group-hover:opacity-100 cursor-pointer transition-all" /> */}
                  </div>

                  <div className={`group flex items-center justify-between transition-all duration-500 delay-700 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
                    <p className="text-gray-800 group-hover:text-blue-600 transition-colors">Hedging for crash protection</p>
                    {/* <Info size={18} className="text-blue-500 opacity-70 group-hover:opacity-100 cursor-pointer transition-all" /> */}
                  </div>

                  <div className={`group flex items-center justify-between transition-all duration-500 delay-900 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
                    <p className="text-gray-800 group-hover:text-blue-600 transition-colors">AIFs, REITs, InvIT</p>
                    {/* <Info size={18} className="text-blue-500 opacity-70 group-hover:opacity-100 cursor-pointer transition-all" /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default InvestmentApproach;